import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button'; // TODO: FORM-629 Analytics:
// import {
//   fireUIAnalytics,
//   useAnalyticsEvents,
// } from '@atlassian/jira-product-analytics-bridge';
// import type { Attributes } from '@atlassian/jira-product-analytics-bridge';

import messages from './messages';
export var ShowFullListButton = function ShowFullListButton(_ref) {
  var onShowFullList = _ref.onShowFullList;
  // const { createAnalyticsEvent } = useAnalyticsEvents();
  var handleShowFullList = useCallback(function () {
    // const analyticsEvent = createAnalyticsEvent({
    //   eventType: 'UI',
    //   action: 'expanded',
    //   actionSubject: 'filterSearch',
    //   actionSubjectId: 'refinementBarFilterSearch',
    // });
    //
    // const attributes: Attributes = {
    //   fieldType: type,
    // };
    //
    // fireUIAnalytics(analyticsEvent, 'refinementBarFilterSearch', attributes);
    onShowFullList();
  }, [onShowFullList]);
  return /*#__PURE__*/React.createElement(Button, {
    onClick: handleShowFullList,
    appearance: "subtle-link",
    testId: "paginated-picker.ui.async-select.show-full-list-button.show-full-list-button"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.showFullListButtonText));
};
export default ShowFullListButton;